import {GraphQLClient} from 'graphql-request';
import {REGISTRY_SHOPPING_GRAPHQL_ENDPOINT} from '../../constants';
import getMemberToken from '../../utils/getMemberToken';
import getOverrideParams from '../../utils/parseUrlParams';

const BACKEND_AB_TESTS_BUCKETING_ID_HEADER = 'TKWW-BUCKETING-ID';
const MAX_ATTEMPTS = 15;

/**
 * Get the member_id from localStorage
 *
 * @return  {String | null}
 */
const getMemberId = () => window.localStorage.getItem('member_id');

/**
 * Await for the member_id to be in localStorage *if a user is logged in*
 *
 * @return  {String | null} the member's id or null if the user is not logged in
 */
const waitForMemberId = () => {
  const memberToken = getMemberToken();

  if (!memberToken) return null;

  const memberId = getMemberId();

  if (memberId) return memberId;

  let attempt = 0;

  if (attempt > MAX_ATTEMPTS) return null;

  return new Promise(resolve => {
    const interval = setInterval(() => {
      const id = getMemberId();

      if (id) {
        resolve(id);
        clearInterval(interval);
      }

      // increment the attempts
      attempt += 1;
    }, 100);
  });
};

const shoppingGraphQLClient = new GraphQLClient(
  REGISTRY_SHOPPING_GRAPHQL_ENDPOINT,
  {
    requestMiddleware: async request => {
      /**
       * Typically, this middleware will already have access to the member id
       * stored in localStorage. However, for an edge case on timing between
       * the MemberContext setting the member id and this middleware reading
       * localStorage, we need to await for the member id to be set.
       */
      const memberId = await waitForMemberId();

      const override = getOverrideParams();
      const memberToken = getMemberToken();
      let {headers} = request;
      if (memberToken) {
        headers = {
          ...headers,
          'membership-session-token': memberToken,
        };
      }

      /**
       * if a member is logged in, add a header to enable backend a/b testing functionality.
       */
      if (memberId) {
        return {
          ...request,
          headers: {
            ...headers,
            [BACKEND_AB_TESTS_BUCKETING_ID_HEADER]: memberId,
            ...override,
          },
        };
      }

      return request;
    },
  },
);

export default shoppingGraphQLClient;
